import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

function Copyright() {
	return (
					<Typography variant="body2" color="text.secondary" align="center">
						{'Copyright © '}
						<Link color="inherit" href="https://mui.com/">
						Your Website
						</Link>{' '}
						{new Date().getFullYear()}
						{'.'}
					</Typography>
					);
}

export default function Footer() {
	return (
					<Box component="footer"
						sx={{py: 1, px: 1, mt: 'auto',
							backgroundColor: (theme) =>
								theme.palette.mode === 'light'
												? theme.palette.grey[200]
												: theme.palette.grey[800],
								}}
						>
					
						<Copyright />
					</Box>
					);
}